import React from "react";
import ImageDiv from "../image-div";
import classes from "./productImageGrid.module.scss";

const ProductImageGrid = (props) => {
    let imgeSrc = [];
    let vidSrc = [];
    let imgI = 0;
    const exts = [".png", ".jpg", ".webp", ".gif"];

    const { imageArr, itemName } = props;
    imageArr.forEach(function (img) {
        let ext = img.substring(img.lastIndexOf("."));
        if (exts.includes(ext)) {
            imgeSrc[imgI] = img;
            imgI++;
        } else {
            vidSrc[imgI] = img;
            imgI++;
        }
    });

    const img_fallback = (event) => {
        event.target.parentNode.childNodes.forEach(function (node) {
            if (node.nodeName == "IMG") node.src = window.no_image;
        });
    }
    return (
        <div className="uk-width-1-1 uk-padding-remove d-none d-lg-block">
            <div className={classes.image_grid} data-uk-lightbox>
                {imageArr.map((image, index) => (
                    <div key={`${image}-${index}`} className={classes.image_grid_item}>
                        <a href={image} className={classes.image_wrap}>
                            <ImageDiv imageUrl={`${image}?resize=498,498&compress=50`}>
                                <img
                                    className="image-resize"
                                    src={`${image}?resize=498,498&compress=50`}
                                    alt={itemName}
                                    onError={img_fallback}
                                    loading="lazy"
                                />
                            </ImageDiv>
                        </a>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default ProductImageGrid;
